const KEY = 'paxsudos:autoLoadImages';                   // global (localStorage)
const EVT = 'paxsudos:autoLoadImagesChanged';

const OVERRIDE_KEY = 'paxsudos:autoLoadImages:override'; // per-toot (sessionStorage)
const EVT_OVR = 'paxsudos:autoLoadImagesOverrideChanged';

export function isAutoLoadEnabled() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw === null) return true; // oletus: PÄÄLLÄ
    return raw === '1';
  } catch { return true; }
}

export function setAutoLoadEnabled(on) {
  try {
    localStorage.setItem(KEY, on ? '1' : '0');
    window.dispatchEvent(new CustomEvent(EVT, { detail: { value: !!on } }));
  } catch {}
}

export function onAutoLoadChange(cb) {
  const h = (e) => cb(!!(e.detail && e.detail.value));
  window.addEventListener(EVT, h);
  return () => window.removeEventListener(EVT, h);
}

// --- per-toot override (voimassa tähän välilehteen / kunnes tootti lähetetään) ---
export function getOverride() {
  try {
    const raw = sessionStorage.getItem(OVERRIDE_KEY);
    if (raw === null) return null;        // ei overridea → käytä globaalia
    return raw === '1';
  } catch { return null; }
}
export function setOverride(onOrNull) {
  try {
    if (onOrNull === null) sessionStorage.removeItem(OVERRIDE_KEY);
    else sessionStorage.setItem(OVERRIDE_KEY, onOrNull ? '1' : '0');
    window.dispatchEvent(new CustomEvent(EVT_OVR, { detail: { value: onOrNull } }));
  } catch {}
}
export function clearOverride() { setOverride(null); }

export function onOverrideChange(cb) {
  const h = (e) => cb(e.detail?.value ?? null);
  window.addEventListener(EVT_OVR, h);
  return () => window.removeEventListener(EVT_OVR, h);
}

// Yhdistetty “voimassa oleva” asetus:
export function getEffective() {
  const ovr = getOverride();
  return ovr === null ? isAutoLoadEnabled() : ovr;
}
